module.exports = __webpack_public_path__ + "media/cases-brand-avic-lazyload-151.25582f9e.mp4";